import { type IIconsVector } from 'shared/ui'

export enum CrmEnum {
  hubSpot = 'hubSpot',
  activeCampaign = 'activeCampaign',
  keap = 'keap',
  salesforce = 'salesforce',
  pipedrive = 'pipedrive',
  none = 'none',
  other = 'other',
}

export enum ContactsCountsEnum {
  count_0_1K = '0 - 1K',
  count_1K_10K = '1K - 10K',
  count_10K_50K = '10K - 50K',
  count_50K_100K = '50K - 100K',
  count_100K_250K = '100K - 250K',
  count_250K_andMore = '250K+',
}

export type ICrm = {
  id: CrmEnum
  name: string
  value: string
  icon: IIconsVector
}

export enum FieldsEnum {
  crm = 'crm',
}

export type IParamsRegisterGtmAnswersStep2 = {
  crm: string
  contacts_number: string
}
